import { CHART_X_PADDING, CHART_X_PADDING_MOBILE } from "../../../../components/chart/hooks"
import { styled, theme } from "../../../../styles/stitches.config"

export const SHeaderContainer = styled("div", {
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  alignItems: "center",

  paddingInline: CHART_X_PADDING_MOBILE / 2,

  "@md": {
    paddingInline: CHART_X_PADDING,
  },

  "@lg": {
    flexDirection: "row",
    alignItems: "none",
  },
})

export const SFooterContainer = styled("div", {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",

  paddingInline: CHART_X_PADDING_MOBILE / 2,

  "@md": {
    paddingInline: CHART_X_PADDING,
  },

  "@lg": {
    flexDirection: "row",
  },
})

export const SCard = styled("div", {
  backgroundColor: theme.colors.white,
  boxShadow: theme.shadows.default,

  display: "flex",
  flexDirection: "column",
  justifyContent: "space-around",
  width: "100%",

  gap: theme.space.s6,
  flexWrap: "wrap",
  padding: `${theme.space.s6} ${theme.space.s6}`,

  "@sm": {
    width: "initial",
    padding: `${theme.space.s11} ${theme.space.s18}`,
  },

  "@md": {
    flexDirection: "row",
  },

  "@lg": {
    width: "100%",
  },
})

export const SCardItem = styled("div", {
  display: "flex",
  alignItems: "center",

  justifyContent: "space-between",
  width: "100%",

  "@md": {
    width: "initial",
    justifyContent: "initial",
  },
})
